import { render } from "./UserAuth.vue?vue&type=template&id=6b04222a&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=6b04222a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b04222a"

export default script